<template>
  <div class="dma-table">
    <sz-table
      :columns="columns"
      :table-data="tableData"
      :row-style="{ height: '60px' }"
      v-loading="loading"
    />
  </div>
</template>

<script>
import SzTable from "@/components/szTable/szTable.vue";
import { Pagination } from "element-ui";
import data from "@/components/map/dma_data.json";

export default {
  name: "DMATable2",
  components: { SzTable, ElPagination: Pagination },
  props: {
    index: String,
    dma: String,
  },
  data() {
    return {
      columns: [
        { field: "id", label: "户号" },
        { field: "name", label: "用户名" },
        { field: "address", label: "房号" },
        // { field: "address", label: "用户地址",width:500 },
        // { field: "number", label: "用户电话" },
        // { field: "investigationDepartment", label: "勘查部门" },
        { field: "caliber", label: "水表口径(mm)" },
        // { field: "type", label: "水表类型" },
        // { field: "position", label: "水表表位" },
        // { field: "installDepartment", label: "安装部门" },
        // { field: "bank", label: "开户行" },
        // { field: "account", label: "账号" },
        // { field: "code", label: "表号" },
        { field: "read", label: "最新抄读(m³)" },
      ],
      tableData: [],
      currentPage: 1,
      total: 0,
      query: {
        id: null,
      },
      loading: false,
    };
  },
  methods: {
    render() {
      this.loading = true;
      this.tableData = data[this.dma][this.index];
      this.loading = false;
    },
  },
  mounted() {
    this.render();
  },
};
</script>

<style scoped lang="less">
.dma-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .pagination {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

::v-deep(.el-table) {
  font-size: 18px;

  .el-table__cell {
    padding: 10px 0;
  }
}

::v-deep.el-pagination__total {
  color: #fff;
}
</style>
